import { Tooltip } from "antd";
import { ColumnType } from "antd/es/table";
import { SenderAmountDto } from "interfaces";
import { formatWithDecimals } from "utils";

import styles from "./refundCurrency.module.css";

export const getColumns = (currency: string): Array<ColumnType<SenderAmountDto>> => {
  return [
    {
      dataIndex: "sender",
      key: "sender",
      title: "Адрес кошелька для возврата",
      width: 380,
      className: `text-clamp-ellipsis ${styles.sender}`,
    },
    {
      dataIndex: "amount",
      key: "amount",
      width: 180,
      title: "Сумма пополнения",
      align: "right",
      className: `text-clamp-ellipsis ${styles.amount}`,
      render: (_: any, record: SenderAmountDto) => {
        return (
          <Tooltip title="Сумма пополнения с этого адреса">
            {formatWithDecimals(record.amount)} {currency}
          </Tooltip>
        );
      },
    },
  ].filter((c) => !!c) as ColumnType<SenderAmountDto>[];
};
